const APPLICATION_INSIGHTS_COOKIE_NAMES = ['ai_session', 'ai_user'];

export function cleanCookies() {
  return Promise.all(APPLICATION_INSIGHTS_COOKIE_NAMES.map(deleteCookie));
}

export function clearBrowserCookiesExceptApplicationInsights() {
  const cookieStore = getCookieStore();
  if (!cookieStore || typeof cookieStore.getAll !== 'function') return Promise.resolve();

  return cookieStore
    .getAll()
    .then(cookies =>
      Promise.all(
        cookies
          .filter(cookie => cookie && cookie.name && !APPLICATION_INSIGHTS_COOKIE_NAMES.includes(cookie.name))
          .map(cookie => deleteCookie(cookie.name)),
      ),
    )
    .then(() => undefined)
    .catch(() => undefined);
}

function deleteCookie(name) {
  const cookieStore = getCookieStore();
  if (!cookieStore || typeof cookieStore.delete !== 'function') return Promise.resolve();

  return cookieStore.delete({ name, path: '/' }).catch(() => undefined);
}

function getCookieStore() {
  if (typeof window === 'undefined') return null;
  return window.cookieStore || null;
}